import { eCDV3ItemTypes } from '../../../ui-toolkit/enums/eCDV3ItemTypes';
import { ICDV3ViewItem, ITitleFeeViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { IOwnerDetailsServiceItem } from '../../../ui-toolkit/cdItems/service/ServiceInterfaces';
import { eTitleFees } from '../../../ui-toolkit/enums/eTitleFees';

export const addOwnerDetailsToLendersPolicy =
  (ownerDetails: IOwnerDetailsServiceItem) =>
  (item: ICDV3ViewItem): ICDV3ViewItem =>
    item.type === eCDV3ItemTypes.title_fee && item.sub_type === eTitleFees.lenders_policy
      ? ({
          ...item,
          order_status: ownerDetails.orderStatus,
          refi_discount: ownerDetails.refiDiscount,
        } as ITitleFeeViewItem)
      : item;
